import { ParentSaleTabs } from "constants/sale";

/**
 * buildBusinessUserDataListBasedOnParentTab takes an accumulator object
 * a sale lot object, a business ID, and an object to be added to the accumulator.
 * This is used to build a list of model objects (sale lots / scans / agencies / etc.)
 * based on the parent tab (either BOUGHT or SOLD) for a business user.
 * @param {object} acc - the accumulator object
 * @param {object} saleLot - sale lot object to be checked against
 * @param {string} businessId - the business ID to check against
 * @param {object} modelObject - the object to be added to the accumulator
 * @returns {Record<string, Array<object>>} - the updated accumulator object
 */
export const buildBusinessUserDataListBasedOnParentTab = (
  acc: object,
  saleLot: SaleLot,
  vendorIdBySaleLotIdLookup: Record<string, string>,
  businessId: string,
  modelObject: object,
) => {
  const vendorId = vendorIdBySaleLotIdLookup[saleLot.id];
  const saleLotForBuyer = vendorId !== businessId;

  const saleLotForVendor = vendorId === businessId;

  if (saleLotForBuyer) {
    if (!Object.keys(acc).includes(ParentSaleTabs.BOUGHT)) {
      acc[ParentSaleTabs.BOUGHT] = [];
    }
    acc[ParentSaleTabs.BOUGHT].push(modelObject);
  }
  if (saleLotForVendor) {
    if (!Object.keys(acc).includes(ParentSaleTabs.SOLD)) {
      acc[ParentSaleTabs.SOLD] = [];
    }
    acc[ParentSaleTabs.SOLD].push(modelObject);
  }
  return acc;
};
